import { FC } from 'react';
import { FilterHeaderProps } from './FilterHeader.types';
import styles from './FileHeader.module.css';
import { Flex } from '@/_components';

export const FilterHeader: FC<FilterHeaderProps> = ({ children }) => {
  return (
    <Flex className={styles.filterHeader} isYCentered={true} isBetween={true}>
      {children}
    </Flex>
  );
};
